








































































































































































import settings from "@/settings.coffee"
import tools from "@/tools.coffee"
import moment from "moment"
import queries from '@/gql/queries.coffee'
import mutation from '@/gql/mutations.coffee'

moment.locale("fr")

gql_mutation = {
    "update_notification_subject_and_body": (uid, subject, body, batch_comment, fake_send)->
        return """
        mutation{
          email_upsert(
            input:{
              uid:"#{uid}",
              subject:"#{subject}",
              body:"#{body}",
              batch_comment:"#{batch_comment}",
              fake_send: #{fake_send}
            }
          ) {
            uid
          }
        }
        """
    "send_notification": (uid, asap, to_gathering)->
        
        if not to_gathering?
            to_gathering = false
        return """
        mutation{
          email_send(id:"#{uid}", asap:#{asap}, to_gathering:#{to_gathering}) {
            ok
          }
        }
        """
    "delete_notification": (uid)->
        return """
        mutation{
          email_delete(id:"#{uid}") {
            ok
          }
        }
        """
    "create_notification": (state_uid, template_uid) ->
        return """
        mutation{
          email_upsert(input:{state:"#{state_uid}", template:"#{template_uid}"}) {
            uid
            created_on
            updated_on
            sent_on
            subject
            body
            template
            state
            clientMutationId
          }
        }
        """
}

gql_query = {
    "get_establishment": (state_uid)->
        return """
        query{
          state (id:"#{state_uid}"){
            review{
              establishment {
                created_on
                name
                notes
                scrap_id
                uid
                updated_on
                batch_notifications
                notify_mon
                notify_tue
                notify_wed
                notify_thu
                notify_fri
                notify_sat
                notify_sun
              }
            }
          }
        }
        """
    "email_set": (state_uid) ->
        return """
        query{
          email_set(state__uid:"#{state_uid}") {
            body
            created_on
            sent_on
            subject
            uid
            pending
            batch_comment
            updated_on
            to
          }
        }
        """
}
 
DAYS = {
    "mon": "Lundi",
    "tue": "Mardi",
    "wed": "Mercredi",
    "thu": "Jeudi",
    "fri": "Vendredi",
    "sat": "Samedi",
    "sun": "Dimanche",
}

empty_notification = {
    "uid": null,
    "subject": null,
    "body": null,
    "batch_comment": null,
    "sent_on": null,
    "to": null,
}

export default {
    "name": "ReviewStateNotification"
    "props": {
        "state": {
            "type": Object
            "required": true
        }
        "to_gathering": false
    }
    "data": ()->
        return {
            "templates": []    
            "show_create_menu": false
            "email_set": []
            "notification": tools.deep_copy(empty_notification)
            "establishment": null
        }    
    "methods":
        "fetch_establishment_data": ()->
            response = await @$http.post(settings.graphqlApiUrl,
                {"query": gql_query.get_establishment(@state.uid)})
            if response.ok
                @establishment = response.body.data.state.review.establishment
        "fetch_data": ()->
            response = await @$http.post(settings.graphqlApiUrl,
                {"query": gql_query.email_set(@state.uid)})
            if response.ok
                @email_set = response.body.data.email_set
                
            resp = await queries.run('get_mail_templates_from_state',
                [@state.uid])
            @templates = resp.body.data.email_template_set_from_state
            @$emit('update-email-set', JSON.parse(JSON.stringify(@email_set)))

        "send_notification": (uid, asap, fake_send)->
            self = @

            {allow, notify_text} = tools.check_modified_fields(self.$store)
            if not allow
                self.$store.dispatch("notify", {
                    text: notify_text,
                    seconds: 5,
                    level: "danger"
                })
                return

            if fake_send
                response = await mutation.run('notify_without_email',
                    [@state.uid, true, @to_gathering])
                self.$refs.closeModalNotification.click()
            else
                # we must serialize \n and " to please GraphQL
                serialized_subject = String(@notification.subject)
                    .replace(/"/g,"'").replace(/\n/g,"\\n").replace(/\r/g,"")
                serialized_body = String(@notification.body)
                    .replace(/"/g,"'").replace(/\n/g,"\\n").replace(/\r/g,"")
                serialized_batch_comment = String(@notification.batch_comment)
                    .replace(/"/g,"'").replace(/\n/g,"\\n").replace(/\r/g,"")

                # first save the email with modified subject & body & comment
                response = await @$http.post(settings.graphqlApiUrl, {
                        "query": gql_mutation.update_notification_subject_and_body(\
                        uid, serialized_subject, serialized_body, serialized_batch_comment, fake_send)})
                if response.ok
                    response = await @$http.post(settings.graphqlApiUrl,
                        {"query": gql_mutation.send_notification(uid, asap, self.to_gathering)})
                    if response.ok
                        @notification = tools.deep_copy(empty_notification)
                    self.$refs.closeModalNotification.click()
        "delete_notification": (uid)->
            response = await @$http.post(settings.graphqlApiUrl,
                {"query": gql_mutation.delete_notification(uid)})
            if response.ok
                @notification = tools.deep_copy(empty_notification)
        "create_notification": (template_uid)->
            # @notification = tools.deep_copy(empty_notification)
            response = await @$http.post(
                settings.graphqlApiUrl,
                {"query": gql_mutation.create_notification(@state.uid, template_uid)}
            )
            @select_notification(response.body.data.email_upsert)
        "select_notification": (data)->
            @notification = {
                "uid": data.uid,
                "subject": data.subject,
                "batch_comment": data.batch_comment,
                "body": data.body,
                "sent_on": data.sent_on,
                "to": data.to,
            }
    "computed":
        "batch_days": ()->
            self = @
            if self.establishment?
                days = []
                for day_slug in ["mon", "tue", "wed", "thu", "fri", "sat", "sun"]
                    if self.establishment["notify_#{day_slug}"]
                        days.push(DAYS[day_slug])
                return days.join(", ")
            else
                return ""
    "mounted": ()->
        self = @
        @fetch_data()
        @fetch_establishment_data()
        @$djangows['onmodelsignals']({"modelName": "email", "appLabel": "core"}, (event)->
            if event.obj?
                if event.obj.state == self.state.uid
                    self.fetch_data()
            else
                if event.obj.state == self.state.uid
                    if event.message == "deleted"
                        self.fetch_data()
        )


}
